export enum AIProviderClientEnum {
  OPENAI = 'openai',
  ANTHROPIC = 'anthropic',
  GOOGLE = 'google',
  AZURE = 'azure',
  MISTRAL = 'mistral',
  DEEPSEEK = 'deepseek',
  CUSTOM = 'custom',
}

export const ALL_PROVIDERS: AIProviderClientEnum[] = Object.values(AIProviderClientEnum);

// Matches the structure returned by get_global_ai_provider_settings RPC
export interface GlobalAIProviderSetting {
  id: string;
  provider_name: AIProviderClientEnum;
  has_api_key: boolean;
  base_url: string | null;
  default_model: string | null;
  is_active: boolean;
  notes: string | null;
  // Add any other fields that are part of the setting but might not be in ProviderSettingsForm's version
}

// You might also want to move SetGlobalAIProviderSettingParams and SetGlobalAIProviderSettingResponse here
// if they are used by more than just ProviderSettingsForm or if GlobalAISettingsPage needs them.
// For now, leaving them in ProviderSettingsForm unless explicitly needed elsewhere.

export interface SetGlobalAIProviderSettingParams {
  p_provider_name: AIProviderClientEnum;
  p_api_key?: string | null;
  p_base_url?: string | null;
  p_default_model?: string | null;
  p_is_active?: boolean | null;
  p_notes?: string | null;
}

export interface SetGlobalAIProviderSettingResponse {
  status: number;
  message: string;
  provider_name?: AIProviderClientEnum;
  id?: string;
  details?: string;
}
